import { productById } from '../v3/products';

export const translations = {
  mr: {
    nav: {
      models: "ड्रोन मॉडेल",
      income: "उत्पन्न",
      subsidy: "सबसिडी",
      training: "प्रशिक्षण",
      stories: "यशोगाथा",
      videos: "व्हिडिओ",
      contact: "संपर्क",
      bookDemo: "डेमो बुक करा",
    },
    header: {
      followUs: "आम्हाला फॉलो करा",
    },
    hero: {
      badge: "DGCA मान्यताप्राप्त",
      titleHero1: "10X",
      titleHero2: "फवारणी.",
      titleHero3: "10X",
      titleHero4: "कमाई.",
      eyebrow: "दरमहा कमवा ₹50,000 ते ₹1,50,000",
      subtitle: "DGCA मान्यताप्राप्त कृषी ड्रोनसह उच्च कार्यक्षम फवारणी, संपूर्ण प्रशिक्षण आणि आजीवन सपोर्टसह स्वतःचा व्यवसाय सुरू करा.",
      tagline: "10X फवारणी. 10X कमाई.",
      ctaDemo: "फ्री डेमो बुक करा",
      ctaPrice: "किंमत पहा",
      ctaWA: "WhatsApp वर बोला",
      ctaCatalogue: "कॅटलॉग डाउनलोड करा",
      featured: "Agrown-10X",
      featuredTag: "बेस्ट सेलर • RTK सोबत",
    },
    trust: {
      title: "भारतातील शेतकऱ्यांचा विश्वास",
      subtitle: "आकड्यांमध्ये आमची कामगिरी",
      acres: "एकर फवारणी",
      drones: "ड्रोन विक्री",
      serviced: "सर्व्हिस केलेले ड्रोन",
      hami: "48 तासांत दुरुस्ती हमी",
      approved: "DGCA मान्यताप्राप्त",
      approvedDesc: "भारत सरकारद्वारा अधिकृत",
      marquee: "DGCA मान्यताप्राप्त • 15,000+ एकर फवारणी • 500+ ड्रोन विकले • 1,000+ सर्व्हिसिंग • सरकारी सबसिडी उपलब्ध",
      startupIndia: "Startup India मान्यताप्राप्त",
      startupIndiaDesc: "DPIIT (भारत सरकार) द्वारा नोंदणीकृत",
      msme: "MSME नोंदणीकृत",
      msmeDesc: "भारत सरकारची अधिकृत MSME उद्यम नोंदणी",
      indiamart: "IndiaMART बेस्ट सेलर 2025",
      indiamartDesc: "महाराष्ट्रातील #1 कृषी ड्रोन विक्रेता",
    },
    trustStrip: {
      items: [
        { primary: "48 तासांत ड्रोन शेतात परत, दुरुस्तीची हमी", secondary: "48-hour field repair guarantee" },
        { primary: "दरमहा 40-50 हजार, कधी 80 हजारांपर्यंत कमाई", secondary: "Rs 40,000-50,000/month, up to Rs 80,000/month" },
        { primary: "तुमच्या कमाईचा पुरावा दाखवणारा कॅल्क्युलेटर", secondary: "See your income proof with our calculator" },
      ],
    },
    superCompact: {
      eyebrow: "NEW • AGROWN-10X",
      headline1: "छोटा आकार.",
      headline2: "मोठा Impact.",
      support: "10 Litre Super Compact Hexacopter — practical agricultural spraying साठी design केलेला कृषी ड्रोन.",
      support2: "Compact दिसतोय. पण कामगिरीत कुठेही compromise नाही.",
      views: "30,000+ VIEWS IN 3 DAYS",
      viewsSub: "Agrown-10X Super Compact बद्दल इतकी चर्चा का होतेय?",
      ctaVideo: "VIDEO पाहा",
      ctaFeatures: "FEATURES पाहा",
      whyTitle: "इतका Compact का?",
      whySub: "कारण मोठं काम करण्यासाठी Drone मोठा असायलाच हवा असं नाही.",
      scaleCaption: "प्रत्यक्ष आकार — एक operator सहज हाताळू शकतो",
      whyItems: [
        { title: "Compact", desc: "आकाराने Super Compact" },
        { title: "Lightweight / Practical", desc: "वाहतूक आणि Handling अधिक Practical" },
        { title: "10 Litre Capacity", desc: "Compact design मध्ये 10 Litre capacity" },
      ],
      metricTank: "Tank Capacity",
      metricTanks: "Tanks / Single Charge",
      metricBattery: "High Power Battery",
      metricYears: "वर्षे",
      metricWarranty: "Warranty",
      featuresTitle: "छोटा Drone. मोठी Engineering.",
      featuresSub: "Agrown-10X Super Compact मध्ये प्रत्येक component practical performance लक्षात घेऊन निवडला आहे.",
      features: [
        { title: "10 Litre Hexacopter", tag: "Made in India", desc: "10 Litre capacity असलेला Super Compact Hexacopter." },
        { title: "2 Years Warranty", tag: "Trust", desc: "विश्वासासोबत 2 वर्षांची Warranty." },
        { title: `${productById.compact.battery} High Power Battery`, tag: "2 Battery Sets", desc: `High-power ${productById.compact.battery} battery system — 2 battery sets.` },
        { title: "GNSS High Accuracy", tag: "", desc: "अधिक अचूक positioning साठी High Accuracy GNSS System." },
        { title: "Metal + Carbon Fiber Body", tag: "Strong & Durable", desc: "Metal आणि Carbon Fiber construction — मजबूत आणि टिकाऊ." },
        { title: "6 Tanks / Single Charge", tag: "", desc: "एका Charge मध्ये 6 Tanks पर्यंत." },
        { title: "Centrifugal Nozzles", tag: "", desc: "Centrifugal Nozzles for agricultural spraying — ड्रोन फवारणीसाठी." },
        { title: "Fast Charger", tag: "", desc: "कामात कमी थांबा. Fast Charging." },
      ],
      engTitle: "Built Strong. Built for the Field.",
      engTitleMr: "शेतासाठी मजबूत. वापरासाठी तयार.",
      engCopy: "Metal आणि Carbon Fiber body मुळे Agrown-10X Super Compact ला मजबूत आणि टिकाऊ construction मिळते.",
      batteryTitle: "6 Tanks. One Charge.",
      batterySub: "Tanks in a Single Charge",
      batterySupport: `${productById.compact.battery} High Power Battery • 2 Battery Sets`,
      videoTitle1: "पाहिलंय 30,000+ लोकांनी.",
      videoTitle2: "आता तुम्हीही पाहा.",
      videoSupport: "Agrown-10X Super Compact प्रत्यक्षात कसा दिसतो आणि कसा काम करतो ते Video मध्ये पाहा.",
      videoName: "इतका छोटा Drone… 6–7 Tanks एका Charge मध्ये?!",
      madeSub: "Designed for Indian Agriculture.",
      madeLine: "10 Litre Hexacopter — Made in India. शेती फवारणीसाठी बनवलेला कृषी ड्रोन.",
      warrantyTitle: "2 YEARS. BUILT WITH CONFIDENCE.",
      warrantyMr: "2 वर्षांची Warranty. तुमच्या विश्वासासाठी.",
      finalCta1: "Agrown-10X Super Compact पाहिला.",
      finalCta2: "आता तुमच्या शेतासाठी योग्य आहे का ते जाणून घ्या.",
      finalCtaSupport: "Product details, availability आणि enquiry साठी आमच्याशी संपर्क करा.",
      finalCtaPrimary: "ENQUIRE NOW",
    },
    madeInIndia: {
      badge: "MADE IN INDIA",
      title: "आम्ही भारतात ड्रोन बनवतो — चायना ड्रोन असेम्बल करत नाही",
      subtitle: "100% स्वदेशी डिझाइन व मॅन्युफॅक्चरिंग. प्रत्येक ड्रोन भारतातच निर्मित केला जातो.",
      origin: "भारत",
      points: [
        "स्वदेशी R&D व डिझाइन टीम",
        "मेक इन इंडिया — चायना असेम्बल्ड नाही",
        "भारतीय सुटे भाग व सपोर्ट",
        "स्थानिक सर्व्हिस व प्रशिक्षण",
      ],
      cta: "आमची फॅक्टरी पहा",
    },
    highlights: {
      label: "आमचे कार्य",
      title: "पंढरपूरहून संपूर्ण महाराष्ट्रभर काम",
      subtitle: "शेतकऱ्यांच्या जीवनात खरा बदल घडवणारे उपक्रम",
      items: [
        { number: "6+", title: "वर्षे अनुभव", desc: "कृषी ड्रोन विक्री व प्रशिक्षणात" },
        { number: "50+", title: "गावांमध्ये सेवा", desc: "महाराष्ट्रातील शेतकऱ्यांसोबत" },
        { number: "200+", title: "प्रशिक्षित पायलट", desc: "DGCA प्रमाणित पायलट निर्मिती" },
        { number: "25+", title: "पीकांवर वापर", desc: "ऊस, कापूस, सोयाबीन, तूर इ." },
      ],
    },
    models: {
      title: "आमची DGCA मान्यताप्राप्त ड्रोन श्रेणी",
      subtitle: "प्रत्येक शेतीसाठी योग्य ड्रोन",
      startsFrom: "सुरुवात",
      gstExtra: "+ GST अतिरिक्त",
      approved: "DGCA मान्यताप्राप्त",
      comingSoon: "लवकरच DGCA मान्यताप्राप्त",
      bestSeller: "बेस्ट सेलर",
      newLaunch: "नवीन लॉन्च",
      rtkIncluded: "RTK समाविष्ट",
      rtkOptional: "RTK ऑप्शनल (अतिरिक्त किंमत)",
      cta: "पूर्ण माहिती व सबसिडी मिळवा",
      list: [
        {
          name: "Super Compact",
          tagline: "छोटा आकार. मोठा Impact.",
          isBestSeller: true,
          rtkIncluded: false,
          comingSoonDgca: true,
          isNew: true,
          gnss: true,
          image: "/supercompact-drone.png",
          features: [
            "10 Litre Super Compact Hexacopter",
            "एका Charge मध्ये 6 Tanks",
            `${productById.compact.battery} Battery — 2 Battery Sets + Fast Charger`,
            "Metal + Carbon Fiber Body",
            "2 वर्षांची Warranty",
            "RTK ऑप्शनल (अतिरिक्त किंमत)",
            "360 Degree Sensor (अतिरिक्त किंमत)"
          ],
        },
        {
          name: "Agrown-10X",
          tagline: "बेस्ट सेलर — मोठ्या शेतांसाठी सर्वोत्तम",
          price: "₹5,00,000",
          isBestSeller: true,
          rtkIncluded: true,
          comingSoonDgca: true,
          image: "/agrown-10x.png",
          features: [
            "10 लिटर टाकी क्षमता",
            "एका Charge मध्ये 10 Tanks",
            `${productById.agrown.battery} Battery — 2 Battery Sets + Fast Charger`,
            "RTK अचूकता तंत्रज्ञान (समाविष्ट)",
            "मोठ्या शेतांसाठी योग्य",
            "2 वर्षांची Warranty",
            "मजबूत स्थिरता व टिकाऊपणा",
            "360 Degree Sensor (अतिरिक्त किंमत)"
          ],
        },
        {
          name: "Agris-H10",
          tagline: "व्यावसायिक ऑपरेटर्ससाठी",
          price: "₹5,50,000",
          isBestSeller: false,
          rtkIncluded: false,
          comingSoonDgca: false,
          image: "/agris-h10.jpeg",
          features: [
            "अत्याधुनिक फवारणी प्रणाली",
            "एका Charge मध्ये 4 Tanks",
            `${productById.agris.battery} Battery — 2 Battery Sets + Fast Charger`,
            "उत्तम कव्हरेज कार्यक्षमता",
            "व्यावसायिक ऑपरेटर्ससाठी आदर्श",
            "RTK ऑप्शनल (अतिरिक्त किंमत)",
          ],
        },
        {
          name: "Agrone-X 2.0",
          tagline: "नवशिक्यांसाठी योग्य",
          price: "₹4,50,000",
          isBestSeller: false,
          rtkIncluded: false,
          comingSoonDgca: false,
          image: "/agrone-x.jpg",
          features: [
            "कॉम्पॅक्ट व किफायतशीर",
            "नवशिक्यांसाठी परिपूर्ण",
            "एका Charge मध्ये 4 - 5 Tanks",
            `${productById.agrone.battery} Battery — 2 Battery Sets + Fast Charger`,
            "सोपी ऑपरेशन व देखभाल",
            "RTK ऑप्शनल (अतिरिक्त किंमत)",
          ],
        },
      ],
    },
    rtk: {
      label: "प्रीसिजन टेक्नॉलॉजी",
      title: "RTK तंत्रज्ञान — GPS पेक्षा अधिक अचूक",
      subtitle: "सेंटीमीटर-स्तरीय अचूकतेसह फवारणी करा",
      compareGps: "GPS अचूकता",
      compareGpsValue: "1–3 मीटर",
      compareRtk: "RTK अचूकता",
      compareRtkValue: "2–3 सेंटीमीटर",
      note: "Agrown-10X मध्ये RTK समाविष्ट. इतर मॉडेल्ससाठी RTK ऑप्शनल अतिरिक्त किंमतीत उपलब्ध.",
      benefits: [
        { title: "अचूक फवारणी", desc: "प्रत्येक रोपापर्यंत योग्य प्रमाणात" },
        { title: "कोणताही ओव्हरलॅप नाही", desc: "केमिकल व वेळेची बचत" },
        { title: "केमिकलची बचत", desc: "25% पर्यंत कमी रसायन खर्च" },
        { title: "उत्पादन वाढ", desc: "सुधारलेले पीक उत्पन्न" },
      ],
    },
    income: {
      label: "उत्पन्न मॉडेल",
      title: "KisanDrone सोबत तुम्ही कसे कमवाल",
      subtitle: "तुमच्या क्षेत्रानुसार उत्पन्न अंदाज पहा",
      acres: "रोज फवारणी (एकर)",
      rate: "प्रति एकर दर (₹)",
      daily: "दररोज उत्पन्न",
      monthly: "महिना उत्पन्न (25 दिवस)",
      yearly: "वार्षिक उत्पन्न",
      example: "उदाहरण: 25 एकर × ₹500 = ₹12,500/दिवस",
      note: "* वास्तविक उत्पन्न हंगाम, क्षेत्र व मागणीवर अवलंबून आहे",
    },
    pricing: {
      title: "ड्रोन गुंतवणूक योजना",
      subtitle: "प्रत्येक बजेटसाठी योग्य पर्याय",
      starting: "पासून सुरुवात",
      gstExtra: "+ GST अतिरिक्त",
      note: "* अंतिम किंमत कॉन्फिगरेशन व अॅक्सेसरीजनुसार बदलू शकते. सर्व किंमतींवर GST अतिरिक्त. सबसिडी नंतर किंमत कमी होऊ शकते.",
      getExact: "नेमकी किंमत मिळवा",
      checkSubsidy: "सबसिडी तपासा",
    },
    subsidy: {
      label: "सरकारी योजना",
      title: "कृषी ड्रोन सबसिडी — 40% ते 100% पर्यंत",
      subtitle: "भारत सरकारच्या विविध योजनांद्वारे पात्रता",
      points: [
        "वैयक्तिक शेतकरी: 50% किंवा ₹5 लाखापर्यंत",
        "SC/ST/महिला/लहान शेतकरी: 50% किंवा ₹5 लाखापर्यंत",
        "FPO (शेतकरी उत्पादक संस्था): 75% किंवा ₹7.5 लाख",
        "कृषी विद्यापीठ/संस्था: 100% अनुदान",
      ],
      cta: "तुमची पात्रता तपासा",
      supportTitle: "आम्ही संपूर्ण अर्ज प्रक्रियेत मदत करतो",
      supportDesc: "डॉक्युमेंटेशनपासून मंजुरीपर्यंत आमची टीम तुमच्यासोबत.",
    },
    training: {
      label: "प्रशिक्षण व सपोर्ट",
      title: "आम्ही फक्त ड्रोन विकत नाही. तुमचा व्यवसाय उभारतो.",
      items: [
        { title: "15-दिवसीय प्रशिक्षण", desc: "DGCA मान्यताप्राप्त पायलट प्रशिक्षण" },
        { title: "आजीवन सर्व्हिसिंग", desc: "नियमित देखभाल व दुरुस्ती" },
        { title: "सुटे भाग उपलब्धता", desc: "जलद व विश्वासार्ह स्पेअर पार्ट्स" },
        { title: "फील्ड सपोर्ट", desc: "तुमच्या शेतात ऑन-साइट सहाय्य" },
      ],
    },
    stories: {
      label: "यशोगाथा",
      title: "खऱ्या शेतकऱ्यांचे, खरे अनुभव",
      items: [
        {
          name: "गणेश नलावडे",
          location: "सोलापूर, महाराष्ट्र",
          before: "₹20,000/महिना",
          after: "₹75,000/महिना",
          quote: "KisanDrone मुळे माझं उत्पन्न खूप वाढलं. आता मी स्वतःचा spraying business चालवतो आणि गावातील शेतकऱ्यांचा विश्वास जिंकला आहे."
        },
        {
          name: "अरुण सालुंखे",
          location: "मिरज, महाराष्ट्र",
          before: "₹15,000/महिना",
          after: "₹80,000/महिना",
          quote: "फक्त 6 महिन्यांतच माझी कमाई ₹2,80,000 पर्यंत पोहोचली. KisanDrone घेतल्याचा निर्णय माझ्या आयुष्यातील सर्वात मोठा बदल ठरला."
        },
        {
          name: "विशाल नवगिरे",
          location: "सोलापूर, महाराष्ट्र",
          before: "₹14,000/महिना",
          after: "₹65,000/महिना",
          quote: "आधी फक्त शेतीवर अवलंबून होतो, पण आता drone मुळे अतिरिक्त कमाई सुरू झाली आहे. काम सोपं आणि जलद झालं आहे."
        },
        {
          name: "घोलप मॅडम",
          location: "अहमदनगर, महाराष्ट्र",
          before: "₹16,000/महिना",
          after: "₹87,000/महिना",
          quote: "महिला म्हणून हा व्यवसाय सुरू केला आणि KisanDrone मुळे मोठं यश मिळालं. आता मी इतर महिलांनाही प्रोत्साहन देते."
        },
        {
          "name": "सुनील जाधव",
          "location": "सातारा, महाराष्ट्र",
          "before": "₹40,000/महिना (इतर मशीन)",
          "after": "₹70,000/महिना",
          "quote": "आधी इतर मशीन वापरून काम करत होतो, पण KisanDrone घेतल्यावर कामाची गती आणि उत्पन्न दोन्ही वाढलं. आता जास्त क्षेत्र कमी वेळात कव्हर करू शकतो."
        },
        {
          "name": "आकाश माने",
          "location": "कराड, महाराष्ट्र",
          "before": "₹36,000/महिना",
          "after": "₹88,000/महिना",
          "quote": "KisanDrone मुळे माझा व्यवसाय पूर्णपणे बदलला. आता मी मोठ्या प्रमाणावर फवारणी करून चांगली कमाई करत आहे."
        },
      ],
    },
    videos: {
      label: "व्हिडिओ गॅलरी",
      title: "KisanDrone कृतीत पहा",
      subtitle: "प्रत्यक्ष शेतातील फवारणी, प्रशिक्षण व यशस्वी शेतकरी",
      channel: "संपूर्ण चॅनेल पहा",
      watchOn: "YouTube वर पहा",
      items: [
        { id: "aj3eETkRpaw", title: "KisanDrone — शेतातील प्रत्यक्ष फवारणी" },
        { id: "idXOvVkP1WM", title: "DGCA मान्यताप्राप्त ड्रोन डेमो" },
        { id: "wRZ79Or7vP8", title: "शेतकरी यशोगाथा — ड्रोन व्यवसाय" },
        { id: "aRe3qxL4LEs", title: "RTK अचूकता व प्रशिक्षण" },
      ],
    },
    business: {
      label: "व्यवसाय संधी",
      title: "स्वतःचा ड्रोन व्यवसाय सुरू करा",
      subtitle: "गुंतवणूक, परतावा, सपोर्ट — सर्व एकाच ठिकाणी",
      points: [
        { title: "कमी गुंतवणूक", desc: "सबसिडीसह ₹2-3 लाखात सुरुवात" },
        { title: "जलद ROI", desc: "6-8 महिन्यात परतावा" },
        { title: "संपूर्ण सपोर्ट सिस्टम", desc: "प्रशिक्षण + सर्व्हिस + मार्केटिंग" },
        { title: "वाढती मागणी", desc: "लाखो एकर फवारणीसाठी प्रतीक्षेत" },
      ],
    },
    cta: {
      label: "मर्यादित जागा",
      title: "मर्यादित डेमो स्लॉट उपलब्ध",
      subtitle: "तुमच्या गावात मोफत डेमो बुक करा. पहिल्या 50 नोंदणींना विशेष सवलत.",
      bookDemo: "डेमो बुक करा",
      call: "आता कॉल करा",
      whatsapp: "WhatsApp करा",
    },
    faq: {
      label: "FAQ",
      title: "तुमच्या प्रश्नांची उत्तरे",
      subtitle: "अॅग्रीकल्चर ड्रोन, प्रशिक्षण, सबसिडी आणि व्यवसायाबाबत वारंवार विचारले जाणारे प्रश्न",
      more: "अधिक प्रश्न आहेत?",
      items: [
        { q: "आम्ही कोणत्या प्रकारचे ड्रोन उपलब्ध करून देतो?", a: "आम्ही फवारणी, मॅपिंग आणि प्रिसिजन फार्मिंगसाठी उच्च बॅटरी बॅकअप आणि जास्त endurance असलेले आधुनिक अ‍ॅग्रीकल्चर ड्रोन उपलब्ध करून देतो." },
        { q: "RPTO प्रशिक्षणासाठी कोण प्रवेश घेऊ शकतो?", a: "१८ वर्षांवरील कोणतीही व्यक्ती RPTO प्रशिक्षणासाठी प्रवेश घेऊ शकते." },
        { q: "ड्रोन चालवण्यासाठी प्रमाणपत्र आवश्यक आहे का?", a: "होय, भारतात व्यावसायिक अ‍ॅग्रीकल्चर ड्रोन चालवण्यासाठी DGCA मान्यताप्राप्त प्रमाणपत्र आवश्यक आहे." },
        { q: "पायलट प्रशिक्षण कार्यक्रमात प्रवेश कसा घ्यावा?", a: "आपण फोन, वेबसाइट किंवा व्हॉट्सअ‍ॅपद्वारे आमच्याशी संपर्क करून प्रशिक्षणासाठी नोंदणी करू शकता." },
        { q: "प्रत्यक्ष ड्रोन उडवण्याचा अनुभव मिळेल का?", a: "होय, आमच्या प्रशिक्षणामध्ये प्रत्यक्ष ड्रोन उडवण्याचा अनुभव आणि फील्ड प्रॅक्टिकल्स दिले जातात." },
        { q: "प्रशिक्षण कार्यक्रमाचा कालावधी किती आहे?", a: "कोर्सनुसार कालावधी बदलतो, परंतु बहुतेक प्रशिक्षण ५ ते १५ दिवसांमध्ये पूर्ण होते." },
        { q: "RPTO प्रशिक्षणामध्ये कोणते विषय शिकवले जातात?", a: "प्रशिक्षणामध्ये ड्रोन फ्लायिंग, सुरक्षा नियम, DGCA नियम, मेंटेनन्स, बॅटरी हँडलिंग आणि फवारणी ऑपरेशन शिकवले जाते." },
        { q: "तुम्ही ड्रोन पायलट प्रशिक्षण देता का?", a: "होय, आम्ही प्रॅक्टिकलसह संपूर्ण अ‍ॅग्रीकल्चर ड्रोन पायलट प्रशिक्षण देतो." },
        { q: "ड्रोनद्वारे कोणत्या पिकांवर फवारणी करता येते?", a: "ऊस, सोयाबीन, कापूस, गहू, भात, द्राक्ष, डाळिंब यांसारख्या अनेक पिकांवर ड्रोनद्वारे फवारणी करता येते." },
        { q: "एक ड्रोन एका दिवसात किती एकर कव्हर करू शकतो?", a: "ड्रोनच्या मॉडेलनुसार आणि परिस्थितीनुसार ड्रोन दिवसाला ४० ते १००+ एकर क्षेत्र कव्हर करू शकतो." },
      ],
    },
    form: {
      title: "तुमच्यासाठी योग्य प्लॅन शोधूया",
      subtitle: "फक्त 30 सेकंदात तपशील भरा, आमची टीम 24 तासांत संपर्क करेल.",
      name: "तुमचे नाव",
      phone: "मोबाईल नंबर",
      location: "गाव / तालुका / जिल्हा",
      requirement: "तुमची गरज",
      requirementPlaceholder: "उदा: 10L ड्रोन, सबसिडी माहिती, डेमो बुकिंग...",
      submit: "पाठवा",
      submitting: "पाठवत आहे...",
      success: "धन्यवाद! आमची टीम लवकरच संपर्क करेल.",
      error: "काहीतरी चुकले. कृपया पुन्हा प्रयत्न करा.",
      required: "आवश्यक फील्ड भरा",
      invalidPhone: "कृपया वैध 10-अंकी भारतीय मोबाईल नंबर टाका",
    },
    footer: {
      tagline: "भारतातील अग्रगण्य कृषी ड्रोन व्यवसाय व उत्पन्न प्लॅटफॉर्म.",
      contact: "संपर्क",
      phone: "फोन",
      location: "ठिकाण",
      locationVal: "पंढरपूर, महाराष्ट्र",
      address: "तीन रस्ता चौक, जुन्या विठाई हॉस्पिटल इमारत, पंढरपूर-कुर्डुवाडी रोड, शेगाव डुमाला, पंढरपूर - ४१३३०४",
      downloadCatalogue: "कॅटलॉग डाउनलोड करा",
      quickLinks: "त्वरित लिंक्स",
      legal: "कायदेशीर",
      privacy: "गोपनीयता धोरण",
      terms: "अटी व शर्ती",
      copyright: "© 2026 KisanDrone. सर्व हक्क राखीव.",
      dgca: "DGCA मान्यताप्राप्त कंपनी",
    },
    blog: {
      title: "ब्लॉग लवकरच येत आहे",
      subtitle: "ड्रोन सबसिडी, उत्पन्न मॉडेल, RTK vs GPS यावर मार्गदर्शक लेख लवकरच.",
      back: "मुख्यपृष्ठावर परत जा",
    },
    lang: {
      switchTo: "English",
      current: "मराठी",
    },
  },

  en: {
    nav: {
      models: "Drone Models",
      income: "Income",
      subsidy: "Subsidy",
      training: "Training",
      stories: "Success",
      videos: "Videos",
      contact: "Contact",
      bookDemo: "Book Demo",
    },
    header: {
      followUs: "Follow us on",
    },
    hero: {
      badge: "DGCA Approved",
      titleHero1: "10X",
      titleHero2: "Spraying.",
      titleHero3: "10X",
      titleHero4: "Earning.",
      eyebrow: "Earn ₹50,000 to ₹1,50,000/month",
      subtitle: "Start your own high-efficiency spraying business with DGCA Approved Agriculture Drones, complete training, and lifetime support.",
      tagline: "10X Spraying. 10X Earning.",
      ctaDemo: "Book Free Demo",
      ctaPrice: "Get Price Details",
      ctaWA: "WhatsApp Now",
      ctaCatalogue: "Download Catalogue",
      featured: "Agrown-10X",
      featuredTag: "Best Seller • RTK Included",
    },
    trust: {
      title: "Trusted by India's Farmers",
      subtitle: "Our impact in numbers",
      acres: "Acres Sprayed",
      drones: "Drones Sold",
      serviced: "Drones Serviced",
      hami: "48-hour repair guarantee",
      approved: "DGCA Approved",
      approvedDesc: "Authorised by Government of India",
      marquee: "DGCA Approved • 15,000+ Acres Sprayed • 500+ Drones Sold • 1,000+ Serviced • Govt Subsidy Available",
      startupIndia: "Startup India Recognised",
      startupIndiaDesc: "Registered under DPIIT, Govt of India",
      msme: "MSME Registered",
      msmeDesc: "Official MSME Udyam Registration, Govt of India",
      indiamart: "IndiaMART Best Seller 2025",
      indiamartDesc: "#1 Agriculture Drone seller in Maharashtra",
    },
    trustStrip: {
      items: [
        { primary: "48-hour field repair guarantee", secondary: "48 तासांत ड्रोन शेतात परत, दुरुस्तीची हमी" },
        { primary: "Rs 40,000-50,000/month, up to Rs 80,000/month", secondary: "दरमहा 40-50 हजार, कधी 80 हजारांपर्यंत कमाई" },
        { primary: "See your income proof with our calculator", secondary: "तुमच्या कमाईचा पुरावा दाखवणारा कॅल्क्युलेटर" },
      ],
    },
    superCompact: {
      eyebrow: "NEW • AGROWN-10X",
      headline1: "Compact size.",
      headline2: "Big Impact.",
      support: "10 Litre Super Compact Hexacopter — designed for practical agricultural spraying.",
      support2: "Looks compact. But zero compromise on performance.",
      views: "30,000+ VIEWS IN 3 DAYS",
      viewsSub: "Why is everyone talking about the Agrown-10X Super Compact?",
      ctaVideo: "WATCH VIDEO",
      ctaFeatures: "SEE FEATURES",
      whyTitle: "Why so compact?",
      whySub: "Because a drone doesn't have to be big to do big work.",
      scaleCaption: "Actual size — easily handled by a single operator",
      whyItems: [
        { title: "Compact", desc: "Super Compact in size" },
        { title: "Lightweight / Practical", desc: "More practical transport and handling" },
        { title: "10 Litre Capacity", desc: "10 Litre capacity in a compact design" },
      ],
      metricTank: "Tank Capacity",
      metricTanks: "Tanks / Single Charge",
      metricBattery: "High Power Battery",
      metricYears: "Years",
      metricWarranty: "Warranty",
      featuresTitle: "Small Drone. Big Engineering.",
      featuresSub: "Every component in the Agrown-10X Super Compact is chosen for practical performance.",
      features: [
        { title: "10 Litre Hexacopter", tag: "Made in India", desc: "A Super Compact Hexacopter with 10 Litre capacity." },
        { title: "2 Years Warranty", tag: "Trust", desc: "2 years of warranty, built on trust." },
        { title: `${productById.compact.battery} High Power Battery`, tag: "2 Battery Sets", desc: `High-power ${productById.compact.battery} battery system — 2 battery sets included.` },
        { title: "GNSS High Accuracy", tag: "", desc: "High Accuracy GNSS System for precise positioning." },
        { title: "Metal + Carbon Fiber Body", tag: "Strong & Durable", desc: "Metal and Carbon Fiber construction — strong and durable." },
        { title: "6 Tanks / Single Charge", tag: "", desc: "Up to 6 tanks on a single charge." },
        { title: "Centrifugal Nozzles", tag: "", desc: "Centrifugal Nozzles for agricultural spraying." },
        { title: "Fast Charger", tag: "", desc: "Less waiting, more working. Fast Charging." },
      ],
      engTitle: "Built Strong. Built for the Field.",
      engTitleMr: "Ready for real farm conditions.",
      engCopy: "The Metal and Carbon Fiber body gives the Agrown-10X Super Compact a strong and durable construction.",
      batteryTitle: "6 Tanks. One Charge.",
      batterySub: "Tanks in a Single Charge",
      batterySupport: `${productById.compact.battery} High Power Battery • 2 Battery Sets`,
      videoTitle1: "Watched by 30,000+ people.",
      videoTitle2: "Now it's your turn.",
      videoSupport: "See how the Agrown-10X Super Compact looks and works in the field, in this video.",
      videoName: "Such a small drone… 6–7 tanks on a single charge?!",
      madeSub: "Designed for Indian Agriculture.",
      madeLine: "10 Litre Hexacopter — Made in India agricultural drone.",
      warrantyTitle: "2 YEARS. BUILT WITH CONFIDENCE.",
      warrantyMr: "2-year warranty. For your peace of mind.",
      finalCta1: "You've seen the Agrown-10X Super Compact.",
      finalCta2: "Now find out if it's right for your farm.",
      finalCtaSupport: "Contact us for product details, availability and enquiry.",
      finalCtaPrimary: "ENQUIRE NOW",
    },
    madeInIndia: {
      badge: "MADE IN INDIA",
      title: "We make drones in India — we do NOT assemble China drones",
      subtitle: "100% swadeshi design and manufacturing. Every drone is built in India.",
      origin: "India",
      points: [
        "In-house R&D and design team",
        "Made in India — not China assembled",
        "Indian spare parts and support",
        "Local servicing and training",
      ],
      cta: "Visit Our Factory",
    },
    highlights: {
      label: "Our Work",
      title: "From Pandharpur to every corner of Maharashtra",
      subtitle: "Real impact in farmers' lives, village by village",
      items: [
        { number: "6+", title: "Years Experience", desc: "In agri drone sales & training" },
        { number: "50+", title: "Villages Served", desc: "Across rural Maharashtra" },
        { number: "200+", title: "Pilots Trained", desc: "DGCA certified drone pilots" },
        { number: "25+", title: "Crop Types", desc: "Sugarcane, Cotton, Soybean, Tur & more" },
      ],
    },
    models: {
      title: "Our DGCA Approved Drone Range",
      subtitle: "The right drone for every farm",
      startsFrom: "Starts from",
      gstExtra: "+ GST extra",
      approved: "DGCA Approved",
      comingSoon: "Coming Soon DGCA Approved",
      bestSeller: "Best Seller",
      newLaunch: "New Launch",
      rtkIncluded: "RTK Included",
      rtkOptional: "RTK Optional (extra cost)",
      cta: "Get Full Details & Subsidy",
      list: [
        {
          name: "Super Compact",
          tagline: "Compact size. Big Impact.",
          isBestSeller: false,
          rtkIncluded: false,
          comingSoonDgca: true,
          isNew: true,
          gnss: true,
          image: "/supercompact-drone.png",
          features: [
            "10 Litre Super Compact Hexacopter",
            "6 tanks on a single charge",
            `${productById.compact.battery} battery — 2 battery sets + fast charger`,
            "Metal + Carbon Fiber body",
            "2 years warranty",
            "RTK optional (extra cost)",
            "360 Degree Sensor (extra Cost)"
          ],
        },
        {
          name: "Agrown-10X",
          tagline: "Best Seller — Ideal for large farms",
          price: "₹5,00,000",
          isBestSeller: true,
          rtkIncluded: true,
          comingSoonDgca: true,
          image: "/agrown-10x.png",
          features: [
            "10L tank capacity",
            "10 tanks on a single charge",
            "RTK precision technology (included)",
            `${productById.agrown.battery} battery — 2 battery sets + fast charger`,
            "Suitable for large farms",
            "Strong stability & durability",
            "360 Degree Sensor (extra Cost)",
          ],
        },
        {
          name: "Agris-H10",
          tagline: "For professional operators",
          price: "₹5,50,000",
          isBestSeller: false,
          rtkIncluded: false,
          comingSoonDgca: false,
          image: "/agris-h10.jpeg",
          features: [
            "Advanced spraying system",
            "Better coverage efficiency",
            "4 tanks on a single charge",
            `${productById.agris.battery} Battery — 2 Battery Sets + Fast Charger`,
            "Ideal for professional operators",
            "RTK optional (extra cost)",
          ],
        },
        {
          name: "Agrone-X 2.0",
          tagline: "Perfect for beginners",
          price: "₹4,50,000",
          isBestSeller: false,
          rtkIncluded: false,
          comingSoonDgca: false,
          image: "/agrone-x.jpg",
          features: [
            "Compact & cost-effective",
            "Perfect for beginners",
            "4 - 5 tanks on a single charge",
            `${productById.agrone.battery} Battery — 2 Battery Sets + Fast Charger`,
            "Easy operation & maintenance",
            "RTK optional (extra cost)",
          ],
        },
      ],
    },
    rtk: {
      label: "Precision Technology",
      title: "RTK Technology — More Accurate than GPS",
      subtitle: "Spray with centimeter-level precision",
      compareGps: "GPS Accuracy",
      compareGpsValue: "1–3 meters",
      compareRtk: "RTK Accuracy",
      compareRtkValue: "2–3 centimeters",
      note: "RTK is included with Agrown-10X. For other models, RTK is optional at extra cost.",
      benefits: [
        { title: "Precise Spraying", desc: "Right amount on every plant" },
        { title: "No Overlap", desc: "Save chemicals and time" },
        { title: "Chemical Savings", desc: "Up to 25% less chemical usage" },
        { title: "Higher Yield", desc: "Improved crop productivity" },
      ],
    },
    income: {
      label: "Income Model",
      title: "How You Earn with KisanDrone",
      subtitle: "Estimate your income based on your area",
      acres: "Daily spraying (acres)",
      rate: "Rate per acre (₹)",
      daily: "Daily Income",
      monthly: "Monthly Income (25 days)",
      yearly: "Yearly Income",
      example: "Example: 25 acres × ₹500 = ₹12,500/day",
      note: "* Actual income depends on season, region, and demand",
    },
    pricing: {
      title: "Drone Investment Plans",
      subtitle: "Right option for every budget",
      starting: "Starts from",
      gstExtra: "+ GST extra",
      note: "* Final pricing may vary based on configuration & accessories. GST extra on all prices. Price may reduce after subsidy.",
      getExact: "Get Exact Price",
      checkSubsidy: "Check Subsidy",
    },
    subsidy: {
      label: "Government Scheme",
      title: "Agri Drone Subsidy — 40% to 100%",
      subtitle: "Eligible under various Government of India schemes",
      points: [
        "Individual farmer: 50% or up to ₹5 Lakh",
        "SC/ST/Women/Small farmer: 50% or up to ₹5 Lakh",
        "FPO (Farmer Producer Org.): 75% or up to ₹7.5 Lakh",
        "Agri university/institution: 100% grant",
      ],
      cta: "Check Your Eligibility",
      supportTitle: "We handle the entire application process",
      supportDesc: "From documentation to approval — our team is with you.",
    },
    training: {
      label: "Training & Support",
      title: "We don't just sell drones. We build your business.",
      items: [
        { title: "15-Day Training", desc: "DGCA approved pilot training" },
        { title: "Lifetime Servicing", desc: "Regular maintenance & repair" },
        { title: "Spare Parts Available", desc: "Fast and reliable spare parts" },
        { title: "Field Support", desc: "On-site assistance at your farm" },
      ],
    },
    stories: {
      label: "Success Stories",
      title: "Real farmers, real earnings",
      items: [
        {
          name: "Ganesh Nalawade",
          location: "Solapur, Maharashtra",
          before: "₹20,000/month",
          after: "₹75,000/month",
          quote: "KisanDrone has significantly increased my income. I now run my own spraying business and have earned the trust of farmers in my village."
        },
        {
          name: "Arun Salunkhe",
          location: "Miraj, Maharashtra",
          before: "₹15,000/month",
          after: "₹80,000/month",
          quote: "In just 6 months, my income reached ₹2,80,000. Buying KisanDrone turned out to be one of the best decisions of my life."
        },
        {
          name: "Vishal Navgire",
          location: "Solapur, Maharashtra",
          before: "₹14,000/month",
          after: "₹65,000/month",
          quote: "Earlier I depended only on farming, but now I earn additional income through drone spraying. The work has become easier and much faster."
        },
        {
          name: "Gholap Madam",
          location: "Ahmednagar, Maharashtra",
          before: "₹16,000/month",
          after: "₹87,000/month",
          quote: "As a woman, I started this business and achieved great success with KisanDrone. Now I encourage other women to start their own ventures."
        },
        {
          "name": "Sunil Jadhav",
          "location": "Satara, Maharashtra",
          "before": "₹40,000/month (Other machines)",
          "after": "₹70,000/month",
          "quote": "Earlier I was working with other machines, but after switching to KisanDrone, both my work speed and income increased. Now I can cover more area in less time."
        },
        {
          "name": "Akash Mane",
          "location": "Karad, Maharashtra",
          "before": "₹36,000/month",
          "after": "₹88,000/month",
          "quote": "KisanDrone completely transformed my business. I now handle large-scale spraying work and earn much better income."
        },
      ],
    },
    videos: {
      label: "Video Gallery",
      title: "See KisanDrone in Action",
      subtitle: "Real farm spraying, training and successful farmers",
      channel: "View full channel",
      watchOn: "Watch on YouTube",
      items: [
        { id: "aj3eETkRpaw", title: "KisanDrone — Real Farm Spraying" },
        { id: "idXOvVkP1WM", title: "DGCA Approved Drone Demo" },
        { id: "wRZ79Or7vP8", title: "Farmer Success — Drone Business" },
        { id: "aRe3qxL4LEs", title: "RTK Precision & Training" },
      ],
    },
    business: {
      label: "Business Opportunity",
      title: "Start Your Own Drone Business",
      subtitle: "Investment, returns, support — all in one place",
      points: [
        { title: "Low Investment", desc: "Start from ₹2-3 Lakh with subsidy" },
        { title: "Fast ROI", desc: "Payback in 6-8 months" },
        { title: "Complete Support System", desc: "Training + service + marketing" },
        { title: "Growing Demand", desc: "Millions of acres waiting" },
      ],
    },
    cta: {
      label: "Limited Slots",
      title: "Limited Demo Slots Available",
      subtitle: "Book a free demo in your village. Special discount for first 50 bookings.",
      bookDemo: "Book Demo",
      call: "Call Now",
      whatsapp: "WhatsApp Now",
    },
    faq: {
      label: "FAQ",
      title: "Your Questions, Answered",
      subtitle: "Frequently asked questions about agriculture drones, training, subsidy, and starting your business",
      more: "Have more questions?",
      items: [
        { q: "What types of drones do you offer?", a: "We offer advanced agriculture drones for spraying, mapping, and precision farming with high battery backup and long endurance." },
        { q: "Who can enroll in RPTO training?", a: "Anyone above 18 years with basic education and interest in drones can enroll in RPTO training." },
        { q: "Is certification mandatory to operate a drone?", a: "Yes, DGCA-approved certification is required for operating commercial agriculture drones legally in India." },
        { q: "How can I enroll in the pilot training program?", a: "You can contact us through phone, website, or WhatsApp to register for upcoming training batches." },
        { q: "Will I get hands-on flying experience?", a: "Yes, our training includes practical flying sessions and real field experience." },
        { q: "What is the duration of the training program?", a: "The duration depends on the course type, but most agriculture drone programs are completed within 5 to 15 days." },
        { q: "What topics are covered in RPTO training?", a: "Training includes drone flying, safety rules, DGCA regulations, maintenance, battery handling, spraying operations, and troubleshooting." },
        { q: "Do you provide pilot training?", a: "Yes, we provide complete agriculture drone pilot training with practical sessions." },
        { q: "Which crops can be sprayed using agriculture drones?", a: "Drones can spray crops like sugarcane, soybean, cotton, wheat, paddy, grapes, pomegranate, and many more." },
        { q: "How many acres can a drone cover in one day?", a: "Depending on the model and conditions, a drone can cover around 40 to 100+ acres per day." },
      ],
    },
    form: {
      title: "Let's find the right plan for you",
      subtitle: "Fill details in 30 seconds. Our team contacts within 24 hours.",
      name: "Your Name",
      phone: "Mobile Number",
      location: "Village / Taluka / District",
      requirement: "Your Requirement",
      requirementPlaceholder: "e.g., 10L drone, subsidy info, demo booking...",
      submit: "Submit",
      submitting: "Submitting...",
      success: "Thank you! Our team will contact you shortly.",
      error: "Something went wrong. Please try again.",
      required: "Please fill required fields",
    },
    footer: {
      tagline: "India's leading agriculture drone business & income platform.",
      contact: "Contact",
      phone: "Phone",
      location: "Location",
      locationVal: "Pandharpur, Maharashtra",
      address: "Teen Rasta Chowk, Old Vitthai Hospital Building, Pandharpur–Kurduwadi Road, Shegoan Dumala, Pandharpur – 413304",
      downloadCatalogue: "Download Catalogue",
      quickLinks: "Quick Links",
      legal: "Legal",
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
      copyright: "© 2026 KisanDrone. All rights reserved.",
      dgca: "DGCA Approved Company",
    },
    blog: {
      title: "Blog Coming Soon",
      subtitle: "Guides on drone subsidy, income models, RTK vs GPS — coming soon.",
      back: "Back to Home",
    },
    lang: {
      switchTo: "मराठी",
      current: "English",
    },
  },
};
